import sensors from "sa-sdk-javascript";
import store from "@/store";
import { getUaType } from './ua'

const getUserStatus = () => {
  try {
    const { uid, vipEndAt } = store.state.user.userInfo || {};
    // 未登录
    if (!uid) return "unlogin";
    const now = Math.floor(Date.now() / 1000);
    if (vipEndAt === 0) {
      // 非会员
      return "nonmember";
    } else if (vipEndAt >= now) {
      // 会员
      return "member";
    } else {
      // 已过期
      return "member_expired";
    }
  } catch {
    return "unlogin";
  }
};

const project =
  process.env.NODE_ENV === "production" ? "laoshibang" : "laoshibang_test";

sensors.init({
  server_url: `https://taluanaly.speiyou.com:8106/sa?project=${project}`,
  is_track_single_page: true, // 单页面配置，默认关闭。开启后自动监听 URL 有变化就会触发 $pageview 事件
  use_client_time: true,
  send_type: "beacon",
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: "default",
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: "not_collect",
  },
});
// 动态公共属性
sensors.registerPage({
  teacher_user_id: () => {
    try {
      const { uid } = store.state.user.userInfo || {};
      return uid ? `${uid}` : "000000";
    } catch {
      return "000000";
    }
  },
  user_identity: () => getUserStatus(),
  ua: () => getUaType(),
  ab_group: () => {
     const abTestInfo = JSON.parse(localStorage.getItem('abTestInfo'));
     console.log('ab_group', abTestInfo, abTestInfo?.strategy === "A" ? 0 : 1)
    return abTestInfo?.strategy === "A" ? 0 : 1; // 0为实验组，1为对照组
  },
});

sensors.quick("autoTrack"); //用于采集 $pageview 事件
